import { Component, inject } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogClose,
  MatDialogContent,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { webDtos, webEnums } from '@vectronic/openApi-customer';
import { DetailsItemComponent } from '@vectronic/ui';
import { Translator } from '@vectronic/util';
import { DatatableComponent } from '../../components/datatable/datatable.component';
import { DatatableConfig } from '../../types/datatable-configuration';

@Component({
  selector: 'table-airtime-connection-dialog',
  templateUrl: './airtime-connection-dialog.component.html',
  styleUrls: ['./airtime-connection-dialog.component.scss'],
  imports: [
    MatDialogClose,
    MatDialogTitle,
    MatDialogContent,
    DatatableComponent,
    DetailsItemComponent,
    MatIcon,
    MatIconButton,
  ],
})
export class AirtimeConnectionDialogComponent {
  data: {
    connections: webDtos.AirtimeConnection[];
    deviceId: number;
    bytes: number;
    inclusiveBytes?: number;
    reportLabel: string;
    paymentAccountLabel: string;
    currency: webEnums.Currency;
    totalDataFee: number;
  } = inject(MAT_DIALOG_DATA);

  datatableConfig: DatatableConfig<webDtos.AirtimeConnection> = {
    uniqueId: 'airtime-connections',
    title: 'Airtime Connections',
    columns: [
      {
        columnId: 1,
        headerName: 'SCTS',
        fieldName: 'scts',
        translator: ({ scts }) => Translator.utcDate(scts),
      },
      {
        columnId: 3,
        headerName: 'Data Fee',
        fieldName: 'dataFee',
        translator: ({ dataFee }) => `${dataFee} ${this.data.currency}`,
      },
      {
        columnId: 4,
        headerName: 'Bytes',
        fieldName: 'bytes',
      },
    ],
    disablePagination: true,
    sort: { internal: true },
    disableEditColumns: true,
    disableDragColumns: true,
    compact: true,
  };
}
